import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext/AuthContext";

const Index = () => {
  const auth = useContext(AuthContext);
  return auth;
};

export default Index;
